import { render, staticRenderFns } from "./LinkTransaction.vue?vue&type=template&id=a80003c0&"
import script from "./LinkTransaction.vue?vue&type=script&lang=ts&"
export * from "./LinkTransaction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports